import { Component } from "react"

class UserNameKana extends Component{
    constructor(props){
        super(props)
        this.name = "よみがな"
    }
    validate(callbackDialog,requireCheck){
        if(requireCheck && String(this.props).trim().length === 0){
            callbackDialog("エラー",this.name + "は必須です。")
            return false
        }
        if(this.props.length > 128){
            callbackDialog("エラー",this.name + "は128文字以内にしてください。")
            return false
        }
        return true
    }
}

export default UserNameKana;